<div *ngIf="pendienteCargar === true">
  <div class="modal-header bg-light">
    <h4 class="modal-title">Carga masiva de aerovales</h4>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="guardando" (click)="closeModal()"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="form">
      <div class="row justify-content-center">
        <div class="col-10 border rounded p-3">
          <div class="row mb-3">
            <div class="col-12">
              <span class="fw-bold me-2">Plantilla de ejemplo:</span>
              <button class="btn btn-primary btn-sm" id="descargar-plantilla" [disabled]="procesando" (click)="descargarPlantilla()">
                Descargar plantilla
              </button>
            </div>
          </div>

          <!-- Separador -->
          <hr class="my-3">

          <!-- Título subir archivo -->
          <div class="row mb-3">
            <div class="col-12 fw-bold">Subir archivo adjunto:</div>
          </div>

          <!-- Input file -->
          <div class="row mb-3">
            <div class="col-12">
              <input #inputFile type="file" class="form-control" name="profile"
                     (change)="onSelectedFile($event)" (click)="resetearArchivo()"
                     id="validatedCustomFile" [disabled]="procesando" formControlName="inputFile" required>
              <div class="form-text">{{ userFileName }}</div>
            </div>
          </div>

          <!-- Progress bar -->
          <div class="row" *ngIf="fileUpload != null && fileUpload.status==='progress'">
            <div class="col-12">
              <div class="progress" style="height: 20px;">
                <div class="progress-bar" role="progressbar" [style.width.%]="fileUpload.message"
                     aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                  {{fileUpload.message}}%
                </div>
              </div>
            </div>
          </div>

          <!-- Indicador de procesamiento de Excel -->
          <div class="row mb-3" *ngIf="procesando">
            <div class="col-12">
              <div class="d-flex justify-content-center align-items-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span class="ms-2">Procesando archivo Excel...</span>
              </div>
            </div>
          </div>

          <div class="row mb-3" *ngIf="guardando">
            <div class="col-12">
              <div class="alert alert-info" role="alert">
                {{ mensajeProcesamiento || ('Procesando (' + bloquesCargados + ' de ' + bloquesTotales + ' bloques)...') }}
              </div>
              <div class="progress" style="height: 20px;">
                <div class="progress-bar progress-bar-striped progress-bar-animated"
                     role="progressbar"
                     [style.width.%]="porcentajeCarga"
                     [attr.aria-valuenow]="porcentajeCarga"
                     aria-valuemin="0" aria-valuemax="100">
                  {{ porcentajeCarga }}%
                </div>
              </div>
              <div class="text-end small mt-1">
                Bloque {{ bloquesCargados }} / {{ bloquesTotales }}
              </div>
            </div>
          </div>

          <!-- Mensajes de error de archivo -->
          <div class="row" *ngIf="fileUpload != null && fileUpload.length>0">
            <div class="col-12">
              <div class="alert alert-warning" role="alert">
                <div *ngFor="let msg of fileUpload">
                  <p class="mb-1">{{ msg.description }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Error conexión backend -->
          <div class="row" *ngIf="errorConexionBackend">
            <div class="col-12">
              <div class="alert alert-danger" role="alert" [innerHTML]="errorConexionBackend">
              </div>
            </div>
          </div>

          <!-- Error datos Excel -->
          <div class="row" *ngIf="errorDatosExcel">
            <div class="col-12">
              <div class="alert alert-danger" role="alert" [innerHTML]="errorDatosExcel">
              </div>
            </div>
          </div>
          <!-- Sin errores -->
          <div class="row" *ngIf="sinErrores">
            <div class="col-12">
              <div class="alert alert-success" role="alert">
                {{ sinErrores }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer bg-light justify-content-center">
    <button [disabled]="guardando || noPuedeCargar || procesando" class="btn btn-primary me-2" (click)="importarAerovalesAeroespecialidad()">
      <span *ngIf="!guardando">Cargar</span>
      <span *ngIf="guardando" class="d-flex align-items-center">
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
        Cargando...
      </span>
    </button>
    <button class="btn btn-secondary" [disabled]="guardando" (click)="closeModal()">Cancelar</button>
  </div>
</div>

<div *ngIf="!pendienteCargar">
  <div class="modal-header bg-light">
    <h5 class="modal-title">Resumen de carga de aerovales</h5>
    <button type="button" class="btn-close" aria-label="Close" [disabled]="guardando" (click)="closeModal()"></button>
  </div>
  <div class="modal-body">
    <div class="row mb-3">
      <div class="col-12 fw-bold fs-5">Recibimos {{ totalAerovales }} aerovales</div>
    </div>
    <!-- Aerovales generados exitosamente -->
    <div class="row mb-2 align-items-center ms-3">
      <div class="col-auto">
        <i class="fa fa-check-circle fa-lg" style="color:green;"></i>
      </div>
      <div class="col">
        Aerovales generados exitosamente: {{ totalAerovales - jsonResponse?.length  }}
      </div>
    </div>
    <!-- Aerovales con errores -->
    <div class="row mb-2 align-items-center ms-3">
      <div class="col-auto">
        <i class="fa fa-close fa-lg" style="color:red;"></i>
      </div>
      <div class="col">
        Aerovales con errores: {{ jsonResponse?.length ?? 0 }}
      </div>
    </div>
    <div *ngIf="jsonResponse && jsonResponse?.length > 0" class="row align-items-center ms-3">
      <div class="col ms-3">
        <div class="ms-4">Filas:</div>
      </div>
    </div>
    <div *ngFor="let resp of jsonResponse">
      <div class="row align-items-center ms-3">
        <div class="col ms-4">
          <div class="ms-4">{{resp.fila}} - {{resp.error}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer bg-light justify-content-center">
    <button class="btn btn-primary me-2" (click)="closeModal()">Aceptar</button>
    <button [disabled]="!jsonResponse || jsonResponse?.length === 0" class="btn btn-primary" (click)="exportarExcel()">Descargar</button>
  </div>
</div>

